var parent = require('../../es/instance/concat');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/stable/instance/concat.js
// module id = 360
// module chunks = 0 1